import 'antd/lib/empty/style'
import { Empty } from './empty'
import './empty.less'

export * from './empty'

export default Empty
